import RandomValuePool from '../common/RandomValuePool';
import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class QuestionGenerator {
  constructor(questionData, questionScene) {

    this.scene = questionScene;

    this.typeData = questionData.types;
    this.symbolIcons = questionData.symbols;
    this.setup();
  };

  setup () {

    this.numberWords = [
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.zero'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.one'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.two'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.three'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.four'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.five'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.six'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.seven'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.eight'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.nine'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbers.ten')
    ];

    this.numberWordsth = [
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.zeroeth'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.first'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.second'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.third'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.fourth'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.fifth'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.sixth'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.seventh'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.eighth'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.ninth'),
      ABCyaPhaser.Localization.instance.getLocalizedString('numbersth.tenth')
    ];
    this.currentQuestion = { category: '', text: '', showIcons: [], choices: [], answerIndex: -1 };

    this.difficultyMod = 5;
    let values = [];
    this.catQuestionInfo = {};
    for (let i = 0; i < this.typeData.length; i++) {
      const td = this.typeData[i];
      const cat = this.typeData[i].cat;
      values.push(this.typeData[i].cat);
      const qi = {};
      this.catQuestionInfo[cat] = {};
      this.catQuestionInfo[cat].count = 0;
      this.catQuestionInfo[cat].difficultyMod = td.difficultyMod;
      this.catQuestionInfo[cat].min = td.min;
      this.catQuestionInfo[cat].max = td.max;
      this.catQuestionInfo[cat].getsHarder = td.getsHarder;
      this.catQuestionInfo[cat].maxCap = td.maxCap;
    }
    this.typeIndexPool = new RandomValuePool(values);

    values = ['^','~','|',']','['];
    this.objectIconPool = new RandomValuePool(values);

    this.generateNewQuestion();
  };

  generateNewQuestion() {
    const typeId = this.typeIndexPool.getValue();

    // typeId = 'HowManyIfAdded';
    this.currentQuestion.category = typeId;
    const catData = this.catQuestionInfo[typeId];

    switch (typeId) {
      case 'HowMany':
        this.makeHowManyQuestion();
        break;

      case 'HowManyMixed':
        this.makeHowManyMixedQuestion();
        break;

      case 'HowManyBaseTen':

        this.makeHowManyBaseTenQuestion();
        break;
      case 'HowManyIfAdded':
        this.makeHowManyMoreBits();
        break;

      case 'HowManyIfSubtracted':
        this.makeHowManyLessBits();
        break;

      case 'Addition':
        this.makeAddition(catData.min,catData.max);
        this.checkMakeHarder(catData);
        break;

      case 'Subtraction':
        this.makeSubraction(catData.min,catData.max);
        this.checkMakeHarder(catData);
        break;

      case 'Order':
        this.makeOrderWithIcons();
        break;

      case 'OrderNextNumber':
        this.makeOrderWithNumbers(catData.min,catData.max, 4);
        this.checkMakeHarder(catData);
        break;

      case 'AdditionForX':
        this.makeAdditionMissing(catData.min,catData.max);
        this.checkMakeHarder(catData);
        break;

      case 'SubtractionForX':
        this.makeSubtractionMissing(catData.min,catData.max);
        this.checkMakeHarder(catData);
        break;

      default:
        break;
    }

    return this.currentQuestion;
  };

  checkMakeHarder(catData) {
    if (catData.getsHarder) {
      if (catData.max < catData.maxCap) {
        // eslint-disable-next-line no-param-reassign
        catData.max += catData.difficultyMod;
      }
    }
  };

  makeHowManyQuestion() {
    const iconchar = this.objectIconPool.getValue();
    this.objectIconPool.restart();
    this.currentQuestion.text = ABCyaPhaser.Localization.instance.getLocalizedString('questions.how_many');
    const answer = Phaser.Math.Between(3,5);
    let startAt = answer + (Phaser.Math.Between(1,3) - 3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {

      startAt += answer - startAt + 3;
    }
    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }

    const icon = this.findSymbolIcon(iconchar);
    this.currentQuestion.showIcons = [];
    for (let i = 0; i < answer; i++) {
      this.currentQuestion.showIcons.push(icon);
    }

    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);

  };

  makeHowManyMixedQuestion(min, max) {
    const iconchar = this.objectIconPool.getValue();
    this.currentQuestion.text = ABCyaPhaser.Localization.instance.getLocalizedString('questions.how_many_mixed').replace('~', iconchar);

    const answer = Phaser.Math.Between(3,5);

    let startAt = answer + (Phaser.Math.Between(1,3) - 3);

    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {

      startAt += answer - startAt + 3;
    }
    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }

    const icon = this.findSymbolIcon(iconchar);
    const stralt = this.objectIconPool.getValue();
    this.objectIconPool.restart();
    const iconData = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, icon);

    const alticon = this.findSymbolIcon(stralt);
    let totalWidth = 0;

    const altIconData = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, alticon);
    this.currentQuestion.showIcons = [];

    for (let i = 0; i < answer; i++) {
      this.currentQuestion.showIcons.push(icon);
      totalWidth += iconData.width;
    }

    const extraNum = Phaser.Math.Between(1, 7 - answer);

    for (let i = 0; i < extraNum; i++) {
      if (totalWidth + altIconData.width < this.scene.scale.width) {
        this.currentQuestion.showIcons.push(alticon);
        totalWidth += altIconData.width;
      }
    }
    this.currentQuestion.showIcons = ABCyaPhaser.Arrays.shuffle(this.currentQuestion.showIcons);

    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);

  };

  makeHowManyBaseTenQuestion() {
    this.currentQuestion.text = ABCyaPhaser.Localization.instance.getLocalizedString('questions.how_many');
    const answer = Phaser.Math.Between(1, 10);
    let startAt = answer - Phaser.Math.Between(0,3);
    if (startAt <= 0) {
      startAt = 0;
    }
    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }
    this.currentQuestion.showIcons = [];
    for (let i = 0; i < answer; i++) {
      this.currentQuestion.showIcons.push('abit');
    }

    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);
  };

  makeHowManyMoreBits() {
    const amt = Phaser.Math.Between(1,8);
    this.currentQuestion.text = ABCyaPhaser.Localization.instance.getLocalizedString('questions.how_many_added').replace('~', this.numToWord(amt));
    let possible = 9 - amt;
    possible = Phaser.Math.Between(1,possible);
    const answer = possible + amt;

    let startAt = answer + (Phaser.Math.Between(0,3) - 3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {
      startAt += answer - (startAt + 3);
    }
    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }

    this.currentQuestion.showIcons = [];
    for (let i = 0; i < possible; i++) {
      this.currentQuestion.showIcons.push('abit');
    }
    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);
  };

  makeHowManyLessBits() {

    const n1 = Phaser.Math.Between(1, 10);
    const n2 = Phaser.Math.Between(1, 4);
    const amt = Math.min(n1,n2);
    const showCount = Math.max(n1,n2);
    this.currentQuestion.text = ABCyaPhaser.Localization.instance.getLocalizedString('questions.how_many_minus').replace('~', this.numToWord(amt));
    const answer = showCount - amt;

    let startAt = answer - Phaser.Math.Between(0,3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {

      startAt += answer - startAt + 3;
    }
    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }

    this.currentQuestion.showIcons = [];
    for (let i = 0; i < showCount; i++) {
      this.currentQuestion.showIcons.push('abit');
    }
    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);
  };

  makeSubraction(min, max) {
    const n1 = Phaser.Math.Between(min, max);
    const n2 = Phaser.Math.Between(max - n1, max);

    const s1 = Math.max(n1, n2);

    const answer = Math.min(n1, n2);
    const s2 = s1 - answer;
    this.currentQuestion.text = `${s1} - ${s2} =`;

    let startAt = answer - Phaser.Math.Between(0,3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {
      startAt += answer - (startAt + 3);
    }

    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }
    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.showIcons = [];
    this.currentQuestion.answerIndex = choices.indexOf(answer);
  };

  makeAddition(min, max) {

    const n1 = Phaser.Math.Between(min + 1, max);
    const left = max - n1;
    const n2 = Phaser.Math.Between(min, left);
    const answer = n1 + n2;
    this.currentQuestion.text = `${n1} + ${n2} =`;

    const offset = 1;
    let startAt = answer + (Phaser.Math.Between(0,3) - 3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {
      startAt += answer - (startAt + 3);
    }

    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }
    this.currentQuestion.choices = choices;
    this.currentQuestion.answer = answer;
    this.currentQuestion.showIcons = [];
    this.currentQuestion.answerIndex = choices.indexOf(answer);
  };

  makeOrderWithIcons() {
    const answer = Phaser.Math.Between(1,5);
    const answerSymbol = this.symbolIcons[answer - 1].icon;
    const len = this.symbolIcons.length;
    let iconList = [];
    let choiceList = [];
    let answerChar = 'x';
    for (let i = 0; i < len; i++) {
      iconList.push(this.symbolIcons[i].icon);
      if (i !== answer - 1) {
        choiceList.push(this.symbolIcons[i].char);
      }
      else {
        answerChar = this.symbolIcons[i].char;
      }
    }
    iconList = ABCyaPhaser.Arrays.shuffle(iconList);
    choiceList = ABCyaPhaser.Arrays.shuffle(choiceList);

    let choices = [];
    choices.push(answerChar);
    for (let i = 0; i < 3; i++) {
      choices.push(choiceList[i]);
    }
    choices = ABCyaPhaser.Arrays.shuffle(choices);
    this.currentQuestion.text = `${ABCyaPhaser.Localization.instance.getLocalizedString('questions.which_is').replace('~', this.numToWordeth(iconList.indexOf(answerSymbol) + 1))}?`;

    this.currentQuestion.choices = choices;
    this.currentQuestion.showIcons = iconList;
    this.currentQuestion.answer = answerChar;
    this.currentQuestion.answerIndex = choices.indexOf(answerChar);
  };

  makeOrderWithNumbers(min, max, numbersShown) {
    const n1 = Phaser.Math.Between(min, max);
    let startAt = n1 - Phaser.Math.Between(0,4);
    if (startAt < 0) startAt = 0;
    const displayed = [];
    for (let i = 0; i < numbersShown; i++) {
      displayed.push(startAt + i);
    }
    const answer = numbersShown + startAt;

    let choices = [];
    choices.push(answer);
    for (let i = 1; i < 4; i++) {
      choices.push(answer + i);
    }
    choices = ABCyaPhaser.Arrays.shuffle(choices);
    const str = displayed.join(', ');
    this.currentQuestion.text = `${ABCyaPhaser.Localization.instance.getLocalizedString('questions.what_comes')} \n${str}`;
    this.currentQuestion.choices = choices;
    this.currentQuestion.showIcons = [];
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);

  };

  makeAdditionMissing(min, max) {
    const sum = Phaser.Math.Between(min, max);
    const n1 = sum - Phaser.Math.Between(1,sum - 1);
    const answer = sum - n1;
    let startAt = answer + (Phaser.Math.Between(0,3) - 3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {
      startAt += answer - (startAt + 3);
    }

    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }

    this.currentQuestion.text = `${n1} + ? = ${sum}`;
    this.currentQuestion.choices = choices;
    this.currentQuestion.showIcons = [];
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);

  };

  makeSubtractionMissing(min, max) {
    const n1 = Phaser.Math.Between(min, max);
    const n2 = Phaser.Math.Between(max - n1, max);

    const s1 = Math.max(n1, n2);

    const answer = Math.min(n1, n2);
    const sum = s1 - answer;


    let startAt = answer + (Phaser.Math.Between(0,3) - 3);
    if (startAt <= 0) {
      startAt = 0;
    }
    else if (answer > startAt + 3) {
      startAt += answer - (startAt + 3);
    }

    const choices = [];
    for (let i = 0; i < 4; i++) {
      choices.push(startAt + i);
    }

    this.currentQuestion.text = `${s1} - ? = ${sum}`;
    this.currentQuestion.choices = choices;
    this.currentQuestion.showIcons = [];
    this.currentQuestion.answer = answer;
    this.currentQuestion.answerIndex = choices.indexOf(answer);

  };

  /* *** */
  findSymbolIcon(char) {
    let icon = '';
    const len = this.symbolIcons.length;
    for (let i = 0; i < len; i++) {
      if (this.symbolIcons[i].char === char) {
        icon = this.symbolIcons[i].icon;
        break;
      }
    }
    return icon;
  };

  numToWord(value) {
    return this.numberWords[value];
  };

  numToWordeth(value) {
    return this.numberWordsth[value];
  };
}